import React, { useEffect } from 'react';
import EducationCard from './EducationCard/EducationCard';
import './education.css';

const Education = ({ data }) => {
  
  return (
    <div className='education__container'> 
      <h1>EDUCACIÓN</h1>
      <div className="education__cards-container">
        {data && data.length > 0 ? (
          data.map((experience, index) => (
            <EducationCard key={index} data={experience} />
          ))
        ) : (
          <p className="education__empty-message">No hay educación disponible</p>
        )}
      </div>  
    </div>
  );
};

export default Education;